import React from "react";
import PeopleIcon from "@material-ui/icons/People";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import EventIcon from "@material-ui/icons/Event";

export const ExlyPeopleIcon = (props) => <PeopleIcon {...props} />;
export const ExlyCheckCircleOutlineIcon = (props) => (
  <CheckCircleOutlineIcon {...props} />
);
export const ExlyStarBorderIcon = (props) => <StarBorderIcon {...props} />;
export const ExlyHelpOutlineIcon = (props) => <HelpOutlineIcon {...props} />;
export const ExlyEventIcon = (props) => <EventIcon {...props} />;
